import { render } from "./CinemasEditHalls.vue?vue&type=template&id=8ac6d1a8&scoped=true"
import script from "./CinemasEditHalls.vue?vue&type=script&lang=js"
export * from "./CinemasEditHalls.vue?vue&type=script&lang=js"

import "./CinemasEditHalls.vue?vue&type=style&index=0&id=8ac6d1a8&lang=scss&scoped=true"

import exportComponent from "D:\\main\\spacelab\\cinema-cms\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8ac6d1a8"]])

export default __exports__